/* src/app/shared/services/toast-v2/toast-v2.component.scss */
.toast-container {
  position: fixed;
  top: 86px;
  right: 24px;
  z-index: 100;
  pointer-events: none;
}
.toast-container .toastt {
  height: fit-content;
  width: 343px;
  font-size: 18px;
  letter-spacing: 0.5px;
  border-radius: 16px;
  box-shadow: 1px 2px 10px 0px rgba(34, 34, 34, 0.05);
  text-align: left;
  color: #222222;
  background: #ffffff;
  line-height: 56px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  pointer-events: auto;
}
.toast-container .toastt.toast-active {
  transition: all 0.3s ease-in-out;
  top: 104px;
}
.toast-container .toastt a {
  color: #222222;
  text-decoration: underline;
}
.header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.toast-message-container {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: "Poppins-Regular";
  font-style: normal;
  line-height: 24px;
  width: 100%;
  text-align: left;
  color: #222222;
}
.toast-title {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: left;
  width: 90%;
}
.toast-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px;
  gap: 8px;
}
.body-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.close-button-container {
  display: flex;
  width: 24px;
  align-items: flex-start;
}
.undo-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  cursor: pointer;
}
.alert-success {
  border: 1px solid #4aba96;
}
.success-filter {
  filter: brightness(0) saturate(100%) invert(32%) sepia(74%) saturate(331%) hue-rotate(109deg) brightness(95%) contrast(87%);
}
.danger-filter {
  filter: brightness(0) saturate(100%) invert(30%) sepia(45%) saturate(955%) hue-rotate(314deg) brightness(89%) contrast(86%);
}
.info-filter {
  filter: brightness(0) saturate(100%) invert(31%) sepia(10%) saturate(2494%) hue-rotate(178deg) brightness(94%) contrast(91%);
}
.warning-filter {
  filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(341%) hue-rotate(3deg) brightness(96%) contrast(92%);
}
.alert-danger {
  border: 1px solid #e55e5e;
}
.alert-info {
  border: 1px solid #70a8ff;
}
.alert-warning {
  border: 1px solid #ffd67a;
}
/*# sourceMappingURL=toast-v2.component.css.map */
